// test1573
(1573 && 0);
